import { FieldApi } from '@tanstack/react-form'

export function FieldInfo({ field }: { field: FieldApi<any, any, any, any> }) {
  return (
    <div className="text-xs text-red-500">
      {
        field.state.meta.isTouched && field.state.meta.errors.length
          ? (
              <em>{field.state.meta.errors.join(',')}</em>
            )
          : null
      }

      {field.state.meta.isValidating ? 'Validating...' : null}
    </div>
  )
}
